import { Grid } from "@mui/material";
import { EditableTable } from "components/alove/EditableTable";
import { EnumAutocomplete, TextEnumAutocomplete } from "components/alove/EnumAutocomplete";
import { BoSettingsPageSettings } from "models/BO/BoSettingsPage";
import { Setting, SettingType } from "models/BO/Setting";
import { useEffect, useState } from "react";
import { getSettingsDO, SettingsTypes } from "utils/settingsUtils";

const MDInput = require("components/MDInput").default;

export const EditSettingsPanel = ({settingPanel, setSettingPanel}:{settingPanel: BoSettingsPageSettings, setSettingPanel: (settingPanel: BoSettingsPageSettings) => void}) => {
    useEffect(() => {
        settingPanel.settings ||= []
    }, [settingPanel])

    const [settings, setSettings] = useState([] as Setting[]);
    useEffect(() => {
        getSettingsDO().then((settings) => setSettings(settings));
    }, []);
    return (
        <Grid container spacing={2}>
            <Grid size={6}>
                <MDInput
                    label="Title"
                    fullWidth
                    value={settingPanel.title}
                    onChange={(e) => setSettingPanel({...settingPanel, title: e.target.value})}
                />
            </Grid>
            <Grid size={6}>
                <TextEnumAutocomplete
                    enumName={SettingsTypes}
                    
                    value={settingPanel.publishKey}
                    onChange={(o) => setSettingPanel({...settingPanel, publishKey: o})}
                />
            </Grid>
            <Grid size={12}>
                <EditableTable
                    columns={[{
                        field: "key",
                        headerName: "Key",
                        flex: 1,
                        editable: true,
                        customType: "autocomplete",
                        getOptions: () => settings.map((setting) => ({label: setting.paramName, value: setting.paramName}))
                    },{
                        field: "description",
                        headerName: "Description",
                        editable: true,      
                        customType: "autocomplete",                  
                        getOptions: () => settings.map((setting) => ({label: setting.description || setting.paramName, value: setting.paramName})),
                        flex: 4
                    },{
                        field: "type",
                        headerName: "Type",
                        valueGetter: (v) => Object.keys(SettingType).find((key) => SettingType[key] === v),
                        flex: 1
                    }]}
                    rows={settingPanel.settings.map((settingKey, i) => {
                        const setting = settings.find((setting) => setting.paramName === settingKey);
                        return {
                            key: settingKey,
                            id: settingKey || "empty" + i,
                            description: setting?.description,
                            type: setting?.paramType,
                        }
                    })}
                    onAddRow={async (setting) => {
                        setSettingPanel({...settingPanel, settings: [...settingPanel.settings, (setting.key || setting.description || "") ]})
                        
                    }}
                    processRowUpdate={async (newRow, oldRow) => {
                        const index = settingPanel.settings.indexOf(oldRow.id);
                        settingPanel.settings[index] = newRow.key;
                        setSettingPanel({...settingPanel, settings: settingPanel.settings});
                        newRow.id = newRow.key;
                        return newRow;
                    }}
                    modelName="Setting"
                     onRowOrderChange={(newOrder) => setSettingPanel({...settingPanel, settings: newOrder})}
                />
            </Grid>
        </Grid>
    );
}